module.exports = __webpack_public_path__ + "img/grjc.89fe0534.png";